import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import HTMLReactParser from 'html-react-parser';

export default function Body({links, angelAiLink, sunwestLink}) {
  return (
    <Container fluid id='body-wrapper'>
      <div className="wrapper-logos">
        <Image className='vector-1' src='https://resources.swmc.com/swmc-images/vector-blur-r.webp' />
        <Image className='vector-2' src='https://resources.swmc.com/swmc-images/vector-blue-l.webp' />
      </div>
      <Row className='justify-content-center py-5'>
        <Col md={6} lg={5} className='text-center'>
          <Image
            src={process.env.REACT_APP_SWMC_IMG_CDN + "8am-and-2-hours-logo.png"}
            alt="Thoroughly Reviewed & Underwritten on Demand and Condition Reviewed & Resolved on Demand"
            fluid
          />
        </Col>
      </Row>

      <Row className='justify-content-around'>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src='https://d2w24n4g34usfg.cloudfront.net/SunWestPartners/images/PartnerBenefits/Morgan-logo.png'
                alt='AngelAi'
                className='icons-max-width morgan-icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <div><h4 className='fw-bold'>{HTMLReactParser(angelAiLink)}</h4></div>
              <div className='mt-2'><h5>
                24/7 support from&nbsp;
                {HTMLReactParser(angelAiLink)}, {HTMLReactParser(sunwestLink)}'s proprietary Artificial Intelligence. Your personal loan expert on anything and EVERYTHING you could need!
              </h5></div>
            </Col>
          </Row>
        </Col>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src={process.env.REACT_APP_CALLME_CDN_URL + 'TRUApproval.png'}
                alt='TRU Approval'
                className='icons-max-width icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <div><h4 className='fw-bold'>TRU Approval <span className="registeredtrademark">®</span></h4></div>
              <div className='mt-2'><h5>
                With minimum conditionally guaranteed&nbsp;
                <a href='https://www.swmc.com/truapproval/'
                  target="_blank" rel="noreferrer noopener"
                  title="TRU Approval">
                  TRU Approvals
                </a>,&nbsp;your clients can make offers with no loan contingency
              </h5></div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='justify-content-around'>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src={process.env.REACT_APP_CALLME_CDN_URL + 'Governmentloans.png'}
                alt='Government Loans with minimum FICO of 500'
                className='icons-max-width icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <h4>Government loans with minimum FICO of 500</h4>
            </Col>
          </Row>
        </Col>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src={process.env.REACT_APP_CALLME_CDN_URL + 'Expansiveproductline.png'}
                alt='Expansive Product Line'
                className='icons-max-width icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <h4>Expansive Product Line</h4>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='justify-content-around'>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src={process.env.REACT_APP_CALLME_CDN_URL + '245Processing.png'}
                alt='24/5 Processing and Underwriting'
                className='icons-max-width icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <h4>24/5 Processing and Underwriting</h4>
            </Col>
          </Row>
        </Col>
        <Col lg={5} className='pb-3'>
          <Row className='align-items-baseline pb-3'>
            <Col xs={2} sm={2}>
              <Image
                src={process.env.REACT_APP_CALLME_CDN_URL + 'ManualUnderwriting.png'}
                alt='Manual Underwriting allowed on FHA, VA, and USDA loans'
                className='icons-max-width icon-padding'
              />
            </Col>
            <Col xs={10} sm={10}>
              <h4>Manual Underwriting allowed on FHA, VA, and USDA loans</h4>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='tru-terms'>
        <p>
          Visit&nbsp;
          <a href='https://www.swmc.com/tru-terms'
            target="_blank" rel="noreferrer noopener"
            title="swmc.com/tru-terms" className="true-terms-text">
            www.swmc.com/tru-terms
          </a>&nbsp;
          for TRU Approval® terms and conditions.
        </p>
        <p>Realtor® is a registered trademark of National Association of Realtors.</p>
      </Row>
      <Row className='justify-content-around'>
        <Image
          src='https://resources.swmc.com/swmc-images/Bottom-image.jpg'
          alt='SWMC Call Center is ready to take your call now! Call Today'
          className='w-100 px-0 bottomImg'
        />
      </Row>
    </Container>
  );
}
